import React from 'react';
import cn from 'classnames';
import { Button } from 'seagull';
import styles from "./ServicesListStructure.module.scss";
const ServicesListStructure = /*#__PURE__*/React.forwardRef(function ServicesListStructure(props, ref) {
  const {
    children,
    addServicesTestid,
    emptyState,
    centerVertically,
    onAddService
  } = props;
  return /*#__PURE__*/React.createElement("section", {
    className: cn(styles.root, {
      [styles.centerVertically]: centerVertically
    }),
    ref: ref
  }, children, React.Children.count(children) === 0 && emptyState ? emptyState : /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: styles.addServiceBtn,
    onClick: onAddService,
    "data-testid": addServicesTestid
  }, "Add services"));
});
export default ServicesListStructure;